// extracted by mini-css-extract-plugin
export default {"question":"faq-item_question__Idnil","inner":"faq-item_inner__XWUHE","bronze":"faq-item_bronze__fLuSf"};